export default {
    state: {},
    getters: {},
    mutations: {},
    actions: {
        getSpecifications() {
            return new Promise((resolve, reject) => {
                window.axios.get("/admin/specification/index")
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        deleteSpecification(_, identifier) {
            return new Promise((resolve, reject) => {
                window.axios.delete("/admin/specification/delete/" + identifier)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        createSpecification(_, data) {
            return new Promise((resolve, reject) => {
                window.axios.post("/admin/specification/store", data)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        updateSpecification(_, payload) {
            return new Promise((resolve, reject) => {
                window.axios.post("/admin/specification/update/" + payload.identifier, payload.data)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        singleSpecification(_, identifier) {
            return new Promise((resolve, reject) => {
                window.axios.get("/admin/specification/show/" + identifier)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
    },
}

